export enum ReviewView {
  ParagraphSearch,
  LabelDefinition,
  SideBySideConflict,
  ClusterView,
  DatasetSideBySideConflict = 4
}
